'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import { CustomRegistration } from '@components/CustomRegistration';
import CommonContainer from '@components/CommonContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
export const AL_GHADEER_REGISTRATION_ID = 'eastvaleRegistration';
export default function EastvaleRegistration(props: any) {
  const registrationSection = props?.locale?.section?.find(
    (section: any) => section.type === 'registration' && section.enabled
  );
  if (!registrationSection) return null;
  const { links, leadConfig } = props;
  return (
    <Stack
      component="section"
      className={cn.eastvaleRegistrationWrapper}
      id={AL_GHADEER_REGISTRATION_ID}
    >
      <Box className={cn.eastvaleRegistrationInner}>
        <Box className={cn.eastvaleRegistrationTagline}>
          <ParallaxText
            variant="h2"
            animationType="zoomIn"
            animationDuration={500}
          >
            {ReactHtmlParser(registrationSection?.eastvaleRegistrationHeader)}
          </ParallaxText>
        </Box>
        <Box className={cn.eastvaleRegistrationBody}>
          <CommonContainer
            paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
            maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
            flexGrow={1}
          >
            <Box className={cn.eastvaleRegistrationContent}>
              <Box className={cn.eastvaleRegistrationHeader}>
                <Box className={cn.eastvaleRegistrationTitle}>
                  <ParallaxText
                    variant="h4"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.eastvaleRegistrationTitle
                    )}
                  </ParallaxText>
                </Box>
                <Box className={cn.eastvaleRegistrationData}>
                  <Mobile>
                    <ParallaxText
                      variant="p"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(
                        registrationSection?.eastvaleRegistrationContentMobile
                      )}
                    </ParallaxText>
                  </Mobile>
                  <Desktop>
                    <ParallaxText
                      variant="p"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(
                        registrationSection?.eastvaleRegistrationContentDesktop
                      )}
                    </ParallaxText>
                  </Desktop>
                </Box>
              </Box>
              <Box
                className={cn.eastvaleRegistrationForms}
                {...mergeAos(fadeUpAosProps, getAosDelay(200))}
              >
                <Box className={cn.eastvaleRegistrationItem}>
                  <CustomRegistration
                    t={registrationSection}
                    successPopUpLink={props.links.successPopupRedirection}
                    privacyPolicyLink={props.links.privacyPolicy}
                    termsAndConditionsLink={props.links.termsAndConditions}
                    formId={props.leadConfig.formId}
                    formType={props.leadConfig.formType}
                    projectName={props.leadConfig.projectName}
                    buttonContent={<>Register For a Call</>}
                    variant="modal"
                    className={cn.eastvaleRegistrationOuter}
                    inputClassName={cn.eastvaleRegistrationBlock}
                    elementClassName={cn.eastvaleRegistrationElement}
                    authClassName={cn.eastvaleRegistrationAuth}
                    checkboxClassName={cn.eastvaleRegistrationCheck}
                    marksClassName={cn.eastvaleRegistrationMarks}
                    submitClassName={cn.eastvaleRegistrationButton}
                    wrapperClassName={cn.eastvaleRegistrationSuccessWrapper}
                    submitBlockClassName={cn.eastvaleRegistrationSubmitBlock}
                    contentClassName={cn.eastvaleRegistrationSuccessContent}
                    buttonClassName={cn.eastvaleRegistrationSuccessButton}
                  />
                </Box>
              </Box>
            </Box>
          </CommonContainer>
        </Box>
      </Box>
    </Stack>
  );
}
